//PopupModal.js
import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";

const translations = {
  english: {
    productReview: "Product Review",
    purchaseReview: "Purchase Review",
    opinionMatters: "Your opinion matters to us. Write your thoughts on this product.",
    opinionPurchase: "Your opinion matters to us. Write your thoughts on this purchase.",
    productRating: "Product Rating:",
    purchaseRating: "Purchase Rating:",
    reviewTitle: "Review Title",
    reviewDescription: "Review Description",
    submitReview: "Submit Review",
  },
  spanish: {
    productReview: "Reseña del producto",
    purchaseReview: "Reseña de la compra",
    opinionMatters: "Tu opinión es importante para nosotros. Escribe tus pensamientos sobre este producto.",
    opinionPurchase: "Tu opinión es importante para nosotros. Escribe tus pensamientos sobre esta compra.",
    productRating: "Calificación del producto:",
    purchaseRating: "Calificación de la compra:",
    reviewTitle: "Título de la reseña",
    reviewDescription: "Descripción de la reseña",
    submitReview: "Enviar reseña",
  },
  arabic: {
    productReview: "مراجعة المنتج",
    purchaseReview: "مراجعة الشراء",
    opinionMatters: "رأيك يهمنا. اكتب أفكارك حول هذا المنتج.",
    opinionPurchase: "رأيك يهمنا. اكتب أفكارك حول هذه الشراء.",
    productRating: "تقييم المنتج:",
    purchaseRating: "تقييم الشراء:",
    reviewTitle: "عنوان المراجعة",
    reviewDescription: "وصف المراجعة",
    submitReview: "إرسال المراجعة",
  },
  german: {
    productReview: "Produktbewertung",
    purchaseReview: "Kaufbewertung",
    opinionMatters: "Ihre Meinung ist uns wichtig. Schreiben Sie Ihre Gedanken zu diesem Produkt.",
    opinionPurchase: "Ihre Meinung ist uns wichtig. Schreiben Sie Ihre Gedanken zu diesem Kauf.",
    productRating: "Produktbewertung:",
    purchaseRating: "Kaufbewertung:",
    reviewTitle: "Bewertungstitel",
    reviewDescription: "Bewertungsbeschreibung",
    submitReview: "Bewertung absenden",
  },
  hindi: {
    productReview: "उत्पाद समीक्षा",
    purchaseReview: "खरीद समीक्षा",
    opinionMatters: "आपकी राय हमारे लिए महत्वपूर्ण है। इस उत्पाद पर अपने विचार लिखें।",
    opinionPurchase: "आपकी राय हमारे लिए महत्वपूर्ण है। इस खरीद पर अपने विचार लिखें।",
    productRating: "उत्पाद रेटिंग:",
    purchaseRating: "खरीद रेटिंग:",
    reviewTitle: "समीक्षा शीर्षक",
    reviewDescription: "समीक्षा विवरण",
    submitReview: "समीक्षा जमा करें",
  },
  french: {
    productReview: "Avis sur le produit",
    purchaseReview: "Avis sur l'achat",
    opinionMatters: "Votre opinion compte pour nous. Écrivez vos pensées sur ce produit.",
    opinionPurchase: "Votre opinion compte pour nous. Écrivez vos pensées sur cet achat.",
    productRating: "Évaluation du produit :",
    purchaseRating: "Évaluation de l'achat :",
    reviewTitle: "Titre de l'avis",
    reviewDescription: "Description de l'avis",
    submitReview: "Soumettre l'avis",
  },
};


const PopupModal = ({ language = "english" }) => {
  const t = translations[language] || translations.english;

  const [rating, setRating] = useState(5);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({ title: "", image: "" });
  const [image, setImage] = useState(null);
  const [productRatings, setProductRatings] = useState({});
//const [modalFunction, setModalFunction] = useState(null);
//const [externalHTML, setExternalHTML] = useState("");
//const [modalGrandTotal, setModalGrandTotal] = useState(null);

  // Load saved ratings
  useEffect(() => {
    const savedRatings =
      JSON.parse(localStorage.getItem("productRatings")) || {};
    setProductRatings(savedRatings);
  }, []);

  // Detect click on rating button
  useEffect(() => {
    const handleRatingClick = (event) => {
      event.stopPropagation();

      const button = event.target.closest(".rating-btn");

      if (button) {
        const productTitle = button.getAttribute("data-title");
        const productImage = button.getAttribute("data-image") || "";
        

        setModalData({ title: productTitle, image: productImage });        
        document.body.classList.add("drawer-opened");

        // load saved review
        if (productRatings[productTitle]) {
          const { rating, title, description, image } =
            productRatings[productTitle];
          setRating(rating);
          setTitle(title);
          setDescription(description);
          setImage(image);
        } else {
          setRating(5);
          setTitle("");
          setDescription("");
          setImage(null);
        }

        setOpen(true);
      }
    };

    document.addEventListener("click", handleRatingClick);
    return () => {
      document.removeEventListener("click", handleRatingClick);
    };
  }, [productRatings]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => setImage(reader.result);
  };

const handleSubmit = () => {
  const existing =JSON.parse(localStorage.getItem("productRatings")) || {};
  const newRatings = {
    ...existing,
    [modalData.title]: { rating, title, description, image },
  };
  setProductRatings(newRatings);
  localStorage.setItem("productRatings", JSON.stringify(newRatings));
  window.dispatchEvent(new Event("ratingUpdated"));
  setOpen(false);
};

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle className="d-flex align-items-center bg-dark justify-content-between p-1 text-white mb-0 px-3 fw-normal">
        <span>{modalData.title}{modalData.function}</span>
        <IconButton onClick={() => setOpen(false)} className="text-white">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className="p-0">
        <>
            <div className="border-bottom m-0 p-3 lh-sm">
              {modalData.image ? t.opinionMatters : t.opinionPurchase}
            </div>
            <div className="pb-0 px-3 py-2">
              <div className="mb-2 pb-2 pt-1 d-flex align-items-center justify-content-start">
                
                <span className="d-inline-block fw-bold mb-0 px-2">
                  {modalData.image ? t.productRating : t.purchaseRating}
                </span>

                {[1, 2, 3, 4, 5].map((star) => (
                  <StarIcon
                    key={star}
                    onClick={(e) => {
                      e.stopPropagation();
                      setRating(star);
                    }}
                    sx={{
                      fontSize: "2rem",
                      cursor: "pointer",
                      color: star <= rating ? "orange" : "lightgray",
                    }}
                  />
                ))}
              </div>

              <TextField
                fullWidth
                label={t.reviewTitle}
                size="small"
                className="mb-2"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />

              <TextField
                fullWidth
                size="small"
                label={t.reviewDescription}
                variant="outlined"
                multiline
                rows={4}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />

              <div className="bg-theme-primary-verylight mt-2 d-none">
                {image && (
                  <span className="d-inline-block me-3" style={{ marginTop: 5 }}>
                    <img
                      src={image}
                      alt="Preview"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                      }}
                    />
                  </span>
                )}
                <input type="file" accept="image/*" onChange={handleImageChange} />
              </div>

              <DialogActions className="p-0 my-2">
                <button onClick={handleSubmit} className="btn w-100">
                  {t.submitReview}
                </button>
              </DialogActions>
            </div>
          </>        
      </DialogContent>
    </Dialog>
  );
};

export default PopupModal;
